import { HYDRATE } from 'next-redux-wrapper';

import { TRouterCardProps } from '@r1-frontend/ui-react/organisms/Card/Router/Router';

import * as actions from '~/src/features/internet/store/actions';
import { EAction } from '~/src/features/internet/store/actions/constants';
import { InferValueTypes, THydrateAction } from '~/src/store';

export type TArticle = {
    key: string,
    id: number,
    question: string,
    answer: string,
    isOpen: boolean,
}

export type TSection = {
    key: string,
    visible: boolean,
};

type TLabel = {
    name: string,
    title: string,
    colors?: {
        text: string,
        bg: string,
    },
}

export type TRouter = Omit<
    TRouterCardProps,
    | 'labels'
    | 'title'
    | 'onButtonClick'
    | 'onIncrement'
    | 'onDecrement'
    | 'onCostClick'
> & {
    labels: TLabel[],
    title: string,
};

export interface IInternetState {
    routers: TRouter[],
    articles: Record<string, TArticle>,
    isLoading: boolean,
}

export const initialState: IInternetState = {
    routers: [],
    articles: {},
    isLoading: false,
};

type TActions = ReturnType<InferValueTypes<typeof actions>> | THydrateAction;

const internetReducer = (state = initialState, action: TActions): IInternetState => {
    switch (action.type) {
        case HYDRATE:
            return {
                ...state,
                ...action.payload.internetReducer,
            };
        case EAction.SetLoading:
            return { ...state, isLoading: action.payload };
        case EAction.SetRouters:
            return { ...state, routers: action.payload };
        case EAction.SetArticles:
            return { ...state, articles: action.payload };
        case EAction.ToggleAnswer:
            return {
                ...state,
                articles: {
                    ...state.articles,
                    [action.payload.key]: {
                        ...action.payload,
                        isOpen: !action.payload.isOpen,
                    },
                },
            };
        default:
            return state;
    }
};

export default internetReducer;
